import React, { useState } from "react";
import "react-phone-number-input/style.css";
import { Button, Col, Form, FormCheck, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../styles/register.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import {
  validatePhone,
  validatePassword,
} from "../../utils/validation/login-valid";
import ownerLogin from "../../services/owner-login";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../components/context/UserContext";
const LoginForm = ({ LoginFrom = "LoginPage", onLoginSuccess }) => {
  const [formData, setFormData] = useState({
    phoneNo: "",
    password: "",
  });
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState("");

  const { setAuthentication } = useUser();
  const navigate = useNavigate();
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const phoneError = validatePhone(formData.phoneNo);
    const passwordError = validatePassword(formData.password);

    if (phoneError || passwordError) {
      setErrors({ phoneNo: phoneError, password: passwordError });
    } else {
      setErrors({});
      setApiError("");
      setLoading(true);

      try {
        const response = await ownerLogin.login(formData);
        console.log("Login response:", response);

        if (response.isSuccess) {
          const result = response.result;

          // ✅ Redirect to OTP Verification if status is undefined
          if (!result?.status || result?.status === "Unverified") {
            navigate("/owner-login-otp-verification", {
              state: { phoneNo: formData.phoneNo },
            });
            return;
          }

          const accessToken = result?.accessToken;
          if (LoginFrom === "LoginPage" && accessToken) {
            setAuthentication(true);
            navigate("/my-account/profile");
          } else {
            onLoginSuccess?.();
            setAuthentication(null);
          }
        } else {
          setApiError(
            response.message || "Login failed. Please check your credentials."
          );
        }
      } catch (error) {
        console.error("Login failed:", error);
        setApiError(error.message || "An error occurred. Please try again.");
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <>
      <section className="registration-section">
        <div className="container">
          <div className="login-form-wrap">
            {apiError && (
              <div className="mb-2 text-sm-center">
                <div className="alert-danger rounded p-3">{apiError}</div>
              </div>
            )}
            <div className="login-form-title">
              <h2 className="form-title">Customer Login</h2>
              <p className="mb-0">
                If you have an account with us, please log in.
              </p>
            </div>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col lg={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Phone Number<span className="imp-star">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="phoneNo"
                      placeholder="Enter your phone number"
                      value={formData.phoneNo}
                      onChange={(e) => {
                        const onlyDigits = e.target.value.replace(/\D/g, "");
                        if (onlyDigits.length <= 10) {
                          setFormData({ ...formData, phoneNo: onlyDigits });
                        }
                      }}
                      maxLength={10}
                      isInvalid={!!errors.phoneNo}
                    />

                    <Form.Control.Feedback type="invalid">
                      {errors.phoneNo}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col lg={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Password</Form.Label>
                    <div className="password-input-container">
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder="Enter your Password"
                        value={formData.password}
                        onChange={handleInputChange}
                        isInvalid={!!errors.password}
                      />
                      <span
                        className="password-toggle-icon"
                        onClick={togglePasswordVisibility}
                      >
                        {showPassword ? <FaEye /> : <FaEyeSlash />}
                      </span>
                    </div>
                    <Form.Control.Feedback type="invalid">
                      {errors.password}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col lg={12}>
                  <div className="mb-3 forget-password">
                    <FormCheck
                      type="checkbox"
                      id="remember-me"
                      label="Remember me"
                      className="custom-checkbox"
                    />
                    <Link to={"/forgot-password"} className="pwd">
                      Forgot password?
                    </Link>
                  </div>
                </Col>
              </Row>
              <Button
                type="submit"
                className="btn orange-btn w-100 button-register"
                disabled={loading}
              >
                {loading ? "Logging in..." : "Login"}
              </Button>
            </Form>
            <div className="dont-have-account">
              <span>Don't have an account?</span>
              <Link to={"/register"} className="link-page">
                Register
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LoginForm;
